var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more",
    transform: "translate(-1705 -390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more_horiz_black_24dp_1_",
    "data-name": "more_horiz_black_24dp (1)",
    transform: "translate(1705 390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46228",
    "data-name": "Path 46228",
    d: "M0,0H30V30H0Z",
    fill: "#eaecf2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46229",
    "data-name": "Path 46229",
    d: "M6.5,10A2.5,2.5,0,1,0,9,12.5,2.507,2.507,0,0,0,6.5,10Zm15,0A2.5,2.5,0,1,0,24,12.5,2.507,2.507,0,0,0,21.5,10ZM14,10a2.5,2.5,0,1,0,2.5,2.5A2.507,2.507,0,0,0,14,10Z",
    transform: "translate(1 2.5)",
    fill: "#92a1b6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6db00ccb9bf2d8a8d2ee2d40a6a1c8a5.svg";
export { ForwardRef as ReactComponent };